module.exports = "query IssueActions{issueActions(orderBy:\"id\"){__typename edges{__typename node{__typename id rowId name}}}}"